/**
 * 店舗をエリアへ振り分ける
 *
 * 定義順に判定して1つに決める規則を持つ
 *
 * 振り分けの仕様を単体テストで固定できるよう、Google Maps・DOMには依存しない
 */

import { AreaMembership } from '@/points/arealabels/AreaMembership.ts'
import { matchesArea } from '@/points/arealabels/areaMatching.ts'

/**
 * 店舗をエリアへ振り分ける
 *
 * 1店舗は定義順で最初に一致した1エリアだけに属する
 * 都道府県と国のように粒度の違う定義を同時に使うので、複数に当たったときの重複計上を避ける
 *
 * @param points 振り分ける対象の店舗
 * @param areas 振り分け先のエリア、バックエンドから受け取った並びのまま渡す
 * @param targetField 判定に使うフィールドのキー、全エリアに同じものを使う
 * @returns memberships はエリアごとの割り当てで areas の順序を保つ、unmatched はどのエリアにも属さない店舗
 */
export function groupPoints(points: Point[], areas: AreaLabelArea[], targetField: string): {
  memberships: AreaMembership[]
  unmatched: Point[]
} {
  const memberships = areas.map(area => new AreaMembership(area))
  const unmatched: Point[] = []

  points.forEach(point => {
    const membership = memberships.find(candidate => matchesArea(point, candidate.area, targetField))

    if (!membership) {
      // 定義漏れとして扱えるよう、捨てずに呼び出し側へ渡す
      unmatched.push(point)
      return
    }

    membership.add(point)
  })

  return {
    memberships: memberships,
    unmatched: unmatched
  }
}
